export default "__VITE_ASSET__DbvNXsbS__"